import React, {useState, useEffect} from 'react'
import {TextField, Button, Typography, Paper} from '@material-ui/core'

import FileBase from 'react-file-base64'
import {useDispatch, useSelector} from 'react-redux'

import useStyles from './styles'
import {createPost, updatePost} from '../../actions/posts'

const Form = ({currentId, setCurrentId}) => {
    const[postData, setPostData] = useState({
        author: '', title: '', message: '', tags: '', selectedFile: ''})
    
    const post = useSelector((state) => currentId? state.posts.find((p) => p._id === currentId) : null)
    const classes = useStyles()
    const dispatch = useDispatch();

    useEffect(() => {
        if(post) setPostData(post)
    }, [post])

    const handleSubmit = (e) =>{
        e.preventDefault(); //prevents refresh on page
        if(currentId){
            dispatch(updatePost(currentId, postData))

        }
        else{
            dispatch(createPost(postData))
        }
        clear()
    }


    const clear = () =>{
        setCurrentId(null);
        setPostData({ author: '', title: '', message: '', tags: '', selectedFile: '', startDate:'', endDate:''})
    }

    return(
        <Paper className = {classes.paper}>
                <form autoComplete = "off" noValidate className = {`${classes.root} ${classes.form}`} onSubmit = {handleSubmit}>
                    <Typography variant="h6" >{currentId ? 'Editing' : 'Posting' } an Event!</Typography>
                        <TextField name="author" variant="outlined" label="Author" fullWidth value={postData.author} onChange={(e) => setPostData({...postData, author: e.target.value})}/>
                        <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e) => setPostData({...postData, title: e.target.value})}/>
                        <TextField name="message" variant="outlined" label="Message" fullWidth value={postData.message} onChange={(e) => setPostData({...postData, message: e.target.value})}/>
                        <TextField name="tags" variant="outlined" label="Tags" fullWidth value={postData.tags} onChange={(e) => setPostData({...postData, tags: e.target.value.split(',')})}/>
                        <TextField id="date" label="Start date" type="date" defaultValue="" className={classes.textField} 
                        InputLabelProps={{shrink: true,}} fullWidth value={postData.startDate} onChange={(e) => setPostData({...postData, startDate: e.target.value})}/>
                        <TextField id="date" label="End date" type="date" defaultValue="" className={classes.textField} 
                        InputLabelProps={{shrink: true,}} fullWidth value={postData.endDate} onChange={(e) => setPostData({...postData, endDate: e.target.value})}/>

                        <div className = {classes.fileInput}>
                            <FileBase type = "file" multiple = {false} onDone = {({base64}) => setPostData({...postData, selectedFile: base64})} />
                        </div>
                        <Button className = {classes.buttonSubmit} variant = "contained" color = "primary" size = "large" type = "submit" fullWidth>Upload</Button>
                        <Button variant = "contained" color = "secondary" size = "small" onClick = {clear} fullWidth>Clear</Button>
                </form>
        </Paper>
    )
}

export default Form;